import { render, staticRenderFns } from "./ManagePermissionModal.vue?vue&type=template&id=86939b04&scoped=true"
import script from "./ManagePermissionModal.vue?vue&type=script&lang=js"
export * from "./ManagePermissionModal.vue?vue&type=script&lang=js"
import style0 from "./ManagePermissionModal.vue?vue&type=style&index=0&id=86939b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86939b04",
  null
  
)

export default component.exports